export default "__VITE_ASSET__ChHGHnzb__"